import { React, useState } from "react";
import {
    Box,
    Button,
    Container,
    Center,
    Input 
  } from '@chakra-ui/react'

import contractMint from "../utils/contractMint";

const MintToken = () => {

  const [address, setAddress] = useState("");
  const [tokenId, setTokenId] = useState("");
  
  async function mintToken ()  {
    await contractMint(address, tokenId); 
    setAddress("");
    setTokenId("");
  }
  
  return (
    
    <Container>
        <Box>
            <Input 
                placeholder="Address" 
                value={address} 
                onChange={(event) => setAddress(event.currentTarget.value)} 
            />
            <Input 
                placeholder="TokenId" 
                type="number"
                value={tokenId} 
                onChange={(event) => setTokenId(event.currentTarget.value)} 
            />
            
        </Box>
        <Box mt={2}>
          <Center>
            <Button width='40%'  onClick={() => mintToken()}> Mint Token </Button>    
          </Center>
                        
        </Box>
            
    </Container>

  );
    
};

export default MintToken;